"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./../.");
class TDOpt extends _1.Opt {
    constructor() {
        super(...arguments);
        this.alpha = 0.01;
        this.epsilon = 0.1;
        this.gamma = 0.75;
        this.beta = 0.01;
        this.lambda = 0;
        this.qInitValue = 0;
        this.replacingTraces = true;
        this.smoothPolicyUpdate = false;
        this.numberOfPlanningSteps = 0;
        this.update = 'qlearn';
    }
    setAlpha(alpha) {
        this.alpha = alpha;
    }
    setEpsilon(epsilon) {
        this.epsilon = epsilon;
    }
    setGamma(gamma) {
        this.gamma = gamma;
    }
    setBeta(beta) {
        this.beta = beta;
    }
    setLambda(lambda) {
        this.lambda = lambda;
    }
    setQ(qInitValue) {
        this.qInitValue = qInitValue;
    }
    setReplacingTraces(replacingTraces) {
        this.replacingTraces = replacingTraces;
    }
    setSmoothPolicyUpdate(smoothPolicyUpdate) {
        this.smoothPolicyUpdate = smoothPolicyUpdate;
    }
    setNumberOfPlanningSteps(numberOfPlanningSteps) {
        this.numberOfPlanningSteps = numberOfPlanningSteps;
    }
    setUpdate(update) {
        this.update = update;
    }
}
exports.TDOpt = TDOpt;
//# sourceMappingURL=td-opt.js.map